




import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import CoursePage from 'frontend/views/courses/CoursePage/CoursePage.vue';
import { meta } from 'frontend/utils/decorators';
import { Course } from 'frontend/types';

@Component({
  components: { CoursePage },
  computed: {
    ...mapState('course', ['course']),
    ...mapGetters('response', ['baseUrl', 'requestPath']),
  },
})
export default class CoursePageWrapper extends Vue {
  private course!: Course;
  private baseUrl!: string;
  private requestPath!: string;

  @meta
  private metaInfo() {
    const description = this.course.description
      ? this.course.description.raw
      : 'Brilliant - Thousands of free examples and practice problems in mathematics, \
          physics, SAT, ACT, AP, JEE, olympiads, and more.';

    return {
      title: `Practice ${this.course.name}`,
      meta: [
        { vmid: 'og:type', property: 'og:type', content: 'website' },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: `Learn ${this.course.name} on Brilliant`,
        },
        { vmid: 'og:description', property: 'og:description', content: description },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.course.og_image_override_url || this.course.intro_image_url,
        },
        {
          vmid: 'og:image:alt',
          property: 'og:image:alt',
          content:
            'https://brilliant.org/site_media/version-1a4dfc4f1b/images/open-graph/default.png',
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: `${this.baseUrl}${this.requestPath.split('?')[0]}`,
        },
        { vmid: 'twitter:site', name: 'twitter:site', content: '@brilliantorg' },
        { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      ],
    };
  }
}
